<div class="ud-dialog">
  <div class="ud-header">
    <div class="ud-title-wrap">
      <div class="ud-title-icon"><mat-icon>person_add</mat-icon></div>
      <div><h2 class="ud-title">Invite a user</h2><div class="ud-subtitle">Add a teammate and choose their access level</div></div>
    </div>
    <button mat-icon-button mat-dialog-close class="ud-close" [disabled]="userSaveClick" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>
  <form id="addUser" class="ud-body" (ngSubmit)="saveUser()">
    <div class="ud-field">
      <label class="ud-label">Display name <span class="ud-required">*</span></label>
      <mat-form-field appearance="outline" class="ud-mat"><input matInput placeholder="e.g. Jordan Lee" name="displayName" required [(ngModel)]="user.displayName"></mat-form-field>
    </div>
    <div class="ud-field">
      <label class="ud-label">Email address <span class="ud-required">*</span></label>
      <mat-form-field appearance="outline" class="ud-mat"><input matInput placeholder="name@company.com" type="email" name="email" required [(ngModel)]="user.emailAddress"></mat-form-field>
    </div>
    <div class="ud-field">
      <label class="ud-label">Role <span class="ud-required">*</span></label>
      <mat-form-field appearance="outline" class="ud-mat"><mat-select [(value)]="user.roleId" placeholder="Choose a role">@for (role of roles; track role.id) { <mat-option [value]="role.id">{{role.name}}</mat-option> }</mat-select></mat-form-field>
      <p class="ud-help">The role controls which areas and actions this user can access.</p>
    </div>
  </form>
  <div class="ud-footer">
    <button mat-button mat-dialog-close class="ud-btn-ghost" [disabled]="userSaveClick">Cancel</button>
    <button type="submit" form="addUser" class="ud-btn-primary" [disabled]="userSaveClick">
      @if (userSaveClick) { <mat-spinner diameter="20" strokeWidth="3"></mat-spinner> } @else { <span>Send invitation</span><mat-icon>send</mat-icon> }
    </button>
  </div>
</div>
